import { Domains } from "../data/Domains";


export type AdGroup = {

    domain: string;
    guid: string;
    readonly: boolean;

};


export const adGroups: AdGroup[ ] = [

    {

        domain: Domains.Bma
        , guid: '267a03d9-b447-4362-91dc-57a4a26755cf'
        , readonly: false
    
    },
    {

        domain: Domains.Bma
        , guid: '45bda7fe-064e-40bd-b206-88bf0812ed5a'
        , readonly: true
    
    },
    {

        domain: Domains.Niw
        , guid: '99c07924-e9ad-45d9-91a3-8f508841737c'
        , readonly: false
    
    },
    {

        domain: Domains.Niw
        , guid: 'c0fd534f-3a2d-4e0c-98d6-c4023c98e0a7'
        , readonly: true
    
    },
    {

        domain: Domains.Waio
        , guid: '69b62865-7c62-4f21-9783-907fb1c4a410'
        , readonly: false
    
    },
    {

        domain: Domains.Waio
        , guid: '06512cae-a652-4d29-bfd9-4c3176930939'
        , readonly: true
    
    },
];


